import { useEffect } from 'react';

function useDocumentClick(callback, depend) {
  useEffect(() => {
    function handleDocumentClick(e) {
      callback();
    }

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, depend);
}

export default useDocumentClick;
